var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88385 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88385 35 17.5488 35Z",
    fill: "url(#paint0_radial_321_56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88385 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88385 35 17.5488 35Z",
    fill: "url(#paint1_radial_321_56)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88385 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88385 35 17.5488 35Z",
    fill: "url(#paint2_radial_321_56)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88385 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88385 35 17.5488 35Z",
    fill: "url(#paint3_radial_321_56)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.564 8.76634C23.7268 8.08262 24.557 7.8303 25.835 8.12332C26.9175 8.37565 29.1477 9.51518 30.2954 11.9977C30.5071 12.4536 29.9943 12.5594 29.7582 12.2419C28.9524 11.1594 26.5187 9.43379 24.3617 9.17332C23.4908 9.06751 23.564 8.76634 23.564 8.76634Z",
    fill: "url(#paint4_linear_321_56)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2409 12.7627C25.2409 12.7627 28.0572 13.5441 28.4804 15.8557C28.5048 16.0022 28.513 16.1487 28.4804 16.2952C28.4316 16.5882 28.106 16.8487 27.6502 16.4743C24.8013 14.1952 22.8397 14.6999 21.3909 15.0336C20.8211 15.1638 20.4548 14.5452 20.6909 14.1057C20.7641 13.9755 20.813 13.8371 20.9106 13.7313C22.4246 11.965 25.2409 12.7627 25.2409 12.7627Z",
    fill: "url(#paint5_radial_321_56)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0613 13.4382C25.0613 13.4382 27.3567 14.0731 28.4962 16.1162C28.4962 16.0266 28.4962 15.9452 28.48 15.8557C28.0567 13.5441 25.2404 12.7627 25.2404 12.7627C25.2404 12.7627 22.4241 11.965 20.9102 13.7313C20.8532 13.7964 20.8044 13.8696 20.7637 13.9429C22.766 12.7871 25.0613 13.4382 25.0613 13.4382Z",
    fill: "url(#paint6_linear_321_56)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5334 8.76634C11.3706 8.08262 10.5404 7.8303 9.2625 8.12332C8.17995 8.37565 5.94971 9.51518 4.80204 11.9977C4.59041 12.4536 5.1032 12.5594 5.33925 12.2419C6.14506 11.1594 8.57878 9.43379 10.7358 9.17332C11.6067 9.06751 11.5334 8.76634 11.5334 8.76634Z",
    fill: "url(#paint7_linear_321_56)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85671 12.7627C9.85671 12.7627 7.04043 13.5441 6.61718 15.8557C6.59276 16.0022 6.58462 16.1487 6.61718 16.2952C6.66601 16.5882 6.9916 16.8487 7.44741 16.4743C10.2962 14.1952 12.2579 14.6999 13.7067 15.0336C14.2765 15.1638 14.6428 14.5452 14.4067 14.1057C14.3335 13.9755 14.2846 13.8371 14.1869 13.7313C12.673 11.965 9.85671 12.7627 9.85671 12.7627Z",
    fill: "url(#paint8_radial_321_56)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0364 13.4382C10.0364 13.4382 7.7411 14.0731 6.60156 16.1162C6.60156 16.0266 6.60156 15.9452 6.61784 15.8557C7.0411 13.5441 9.85738 12.7627 9.85738 12.7627C9.85738 12.7627 12.6737 11.965 14.1876 13.7313C14.2446 13.7964 14.2934 13.8696 14.3341 13.9429C12.3318 12.7871 10.0364 13.4382 10.0364 13.4382Z",
    fill: "url(#paint9_linear_321_56)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2809 22.6201C25.1344 22.5957 24.9879 22.6364 24.8821 22.7422C23.0019 24.5085 20.1042 25.4527 17.9228 25.4527H17.5484H17.1739C14.9925 25.4527 12.0867 24.5085 10.2146 22.7422C10.1088 22.6446 9.96231 22.5957 9.8158 22.6201C9.66929 22.6446 9.58789 22.8155 9.66115 22.9539C11.2646 25.7295 14.2356 27.455 17.4588 27.455H17.5565H17.6542C20.8774 27.455 23.8484 25.7376 25.4519 22.9539C25.517 22.8155 25.4356 22.6527 25.2809 22.6201Z",
    fill: "#643800"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2809 22.6201C25.1344 22.5957 24.9879 22.6364 24.8821 22.7422C23.0019 24.5085 20.1042 25.4527 17.9228 25.4527H17.5484H17.1739C14.9925 25.4527 12.0867 24.5085 10.2146 22.7422C10.1088 22.6446 9.96231 22.5957 9.8158 22.6201C9.66929 22.6446 9.58789 22.8155 9.66115 22.9539C9.67743 22.9783 9.6937 23.0108 9.70998 23.0353C9.86463 22.9457 10.0193 22.8643 10.1902 23.0515C11.9728 25.0539 14.6181 26.2504 17.4507 26.2504H17.5484H17.646C20.4949 26.2504 23.1565 25.0376 24.9391 23.0108C25.1019 22.8236 25.2565 22.9132 25.403 23.0108C25.4112 22.9946 25.4274 22.9701 25.4356 22.9539C25.517 22.8155 25.4356 22.6527 25.2809 22.6201Z",
    fill: "url(#paint10_linear_321_56)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_321_56",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4078) scale(21.1115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB82E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_321_56",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4078) scale(16.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_321_56",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.0147 21.8535) rotate(-2.7703) scale(7.36093 5.82433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1795,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    stopColor: "#FA4C0B",
    stopOpacity: 0.7318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#EE4B27",
    stopOpacity: 0.2683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_321_56",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0739 21.8535) rotate(-177.23) scale(7.36093 5.82433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1795,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    stopColor: "#FA4C0B",
    stopOpacity: 0.7318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#EE4B27",
    stopOpacity: 0.2683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_56",
    x1: 26.8901,
    y1: 10.7439,
    x2: 27.3074,
    y2: 8.94769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_321_56",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8029 14.3601) rotate(15.68) scale(3.1451 1.51726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_56",
    x1: 25.4944,
    y1: 11.8809,
    x2: 24.9564,
    y2: 13.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_321_56",
    x1: 8.2069,
    y1: 10.7356,
    x2: 7.78957,
    y2: 8.93943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_321_56",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2833 14.367) rotate(164.32) scale(3.1451 1.51725)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_321_56",
    x1: 9.59349,
    y1: 11.8721,
    x2: 10.1316,
    y2: 13.8316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_321_56",
    x1: 17.5484,
    y1: 23.8561,
    x2: 17.5484,
    y2: 26.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfied);
export default __webpack_public_path__ + "static/media/Satisfied.2e087809f803747a7ecf06c3d3bdc532.svg";
export { ForwardRef as ReactComponent };